import { Menu } from "@assets/icons/Menu";
import avatarUser from "@assets/images/default-avatar.jpg";
import Loader from "@components/Loader/Loader";
import logoutIcon from "assets/icons/logout.png";
import { MobileMenu } from "layouts/appLayout/MobilMenu";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLogoutMutation } from "store/auth/auth.api";
import { logoutUser, setCredentials } from "store/slices/auth.slice";
import "./index.scss";

const ConnectedUserInfo = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);

  const [logout, { isLoading: isLoggingOut }] = useLogoutMutation();

  const handleLogout = async () => {
    try {
      await logout().unwrap();
      dispatch(logoutUser());
      dispatch(setCredentials({ user: null, token: null }));
      navigate("/login");
    } catch (error) {
      console.error("Erreur lors de la déconnexion :", error);
    }
  };
  const [showModal, setShowModal] = useState(false);
  const toggleModal = () => {
    setShowModal(!showModal);
  };
  return (
    <>
      <div className="user-info-card">
        <button onClick={toggleModal} className="icon-btn">
          <Menu />
        </button>
        {user ? (
          <>
            <div className="user-details">
              <p className="user-name">{user?.name || "Utilisateur"}</p>
              <p className="user-email">{user?.email || "Email inconnu"}</p>
            </div>
            <img src={avatarUser} alt="avatar user" className="user-avatar" />
            <img src={logoutIcon} alt="logoutIcon" onClick={handleLogout} />
          </>
        ) : user === null ? (
          <></>
        ) : (
          <Loader />
        )}
      </div>

      {/* ✅ Affiche AlertMessage SEULEMENT si la liste bancaire est vide */}

      <MobileMenu showModal={showModal} toggleModal={toggleModal} />
    </>
  );
};

export default ConnectedUserInfo;
